import { useTranslation } from "react-i18next";
import GenericComponent from "../../../utils/genericComponent/GenericComponent";
import { ReactComponent as Image } from "../../../../assets/img/success-illustration.svg";

const SuccessVideoId = () => {
  const { t } = useTranslation();

  return (
    <GenericComponent
      ImageSrc={Image}
      pageTitle={t`screens.successVideoId.pageTitle`}
      pageSubtitle={t`screens.successVideoId.pageSubtitle`}
      transComponent={<br />}
      buttonLabel={t`screens.successVideoId.backBtn`}
      onClickCallback={() => (window.location.href = "/cb-thirdpillar/")}
    />
  );
};

export default SuccessVideoId;
